import styles from './SegmentedControl.module.css'

/**
 * Compact filter control for segmented options.
 * Each option can have an optional count badge.
 */
export function SegmentedControl({ value, onChange, options, className = '' }) {
  return (
    <div className={`${styles.control} ${className}`} role="tablist">
      {options.map(option => (
        <button
          key={option.value}
          className={`${styles.segment} ${value === option.value ? styles.active : ''}`}
          onClick={() => onChange(option.value)}
          type="button"
          role="tab"
          aria-selected={value === option.value}
        >
          {option.label}
          {option.count != null && option.count > 0 && (
            <span className={styles.count}>{option.count}</span>
          )}
        </button>
      ))}
    </div>
  )
}
